"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmOrderOrderInnerNameToJSON = exports.ConfirmOrderOrderInnerNameFromJSONTyped = exports.ConfirmOrderOrderInnerNameFromJSON = exports.instanceOfConfirmOrderOrderInnerName = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ConfirmOrderOrderInnerName interface.
 */
function instanceOfConfirmOrderOrderInnerName(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfConfirmOrderOrderInnerName = instanceOfConfirmOrderOrderInnerName;
function ConfirmOrderOrderInnerNameFromJSON(json) {
    return ConfirmOrderOrderInnerNameFromJSONTyped(json, false);
}
exports.ConfirmOrderOrderInnerNameFromJSON = ConfirmOrderOrderInnerNameFromJSON;
function ConfirmOrderOrderInnerNameFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'productName': !(0, runtime_1.exists)(json, 'product_name') ? undefined : json['product_name'],
        'image': !(0, runtime_1.exists)(json, 'image') ? undefined : json['image'],
    };
}
exports.ConfirmOrderOrderInnerNameFromJSONTyped = ConfirmOrderOrderInnerNameFromJSONTyped;
function ConfirmOrderOrderInnerNameToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'product_name': value.productName,
        'image': value.image,
    };
}
exports.ConfirmOrderOrderInnerNameToJSON = ConfirmOrderOrderInnerNameToJSON;
